<div
  animate.enter="animate-up"
  animate.leave="animate-down"
  class="w-[30vw] min-h-screen flex items-center justify-center"
> 
 <div class="relative w-full flex flex-col justify-center items-center">
    <img src="assets/images/emblem.png" class="w-20" alt="">
    <span class="text-black text-xl font-bold mt-5 mb-2">{{ 'Check your Email' | concat | translate }}</span>
    <p class="text-gray-dark text-center">{{ 'We have sent password reset instructions' | concat | translate }}</p>
    <div class="w-full mt-3">
      <div class="w-full flex justify-center mb-3">
        <button routerLink="/auth/login" class="w-fit mx-auto" mat-raised-button color="primary">{{ 'Back To Log In' | concat | translate }}</button>
      </div>
    </div>
  </div>
</div>
